"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultTtlMs = 1000 * 60;
/**
 * Holds outgoing messages until a websocket connection is established.
 * Has options to expire if delayed for too long and a callback should a message expire.
 */
class PendingMessageTracker {
    constructor(args = {}) {
        this._pendingMessages = [];
        this._defaultTtlMs = args.defaultTtlMs || DefaultTtlMs;
    }
    addMessageForLater(payload, ttlMs, onExpiration) {
        const pendingMessage = this._pendingMessageData(payload, ttlMs, onExpiration);
        this._pendingMessages.push(pendingMessage);
    }
    unshiftMessage(payload, ttlMs, onExpiration) {
        const pendingMessage = this._pendingMessageData(payload, ttlMs, onExpiration);
        this._pendingMessages.unshift(pendingMessage);
    }
    nextValidMessage() {
        let validMsgToSend;
        while (!validMsgToSend && this._pendingMessages.length) {
            const pending = this._pendingMessages.shift();
            if (this._isValid(pending)) {
                validMsgToSend = pending.payload;
            }
            else {
                try {
                    pending && pending.onExpiration && pending.onExpiration();
                }
                catch (err) {
                    console.warn('Error in provided onExpiration callback for pending websocket message that expired before send.', err);
                }
            }
        }
        return validMsgToSend;
    }
    count() {
        return this._pendingMessages.length;
    }
    clearAll() {
        this._pendingMessages = [];
    }
    _isValid(pm) {
        if (!pm) {
            return false;
        }
        else if (pm.expiresAt === null) {
            return true;
        }
        return pm.expiresAt >= Date.now();
    }
    forEachUnexpired(fn) {
        let msg;
        do {
            msg = this.nextValidMessage();
            msg && fn(msg);
        } while (msg);
    }
    _pendingMessageData(payload, ttlMs, onExpiration) {
        ttlMs = typeof ttlMs === 'number' ? ttlMs : this._defaultTtlMs;
        const expiresAt = typeof ttlMs === 'number' ? Date.now() + ttlMs : null;
        return { payload, expiresAt, onExpiration };
    }
}
exports.default = PendingMessageTracker;
//# sourceMappingURL=pending-message-tracker.js.map